import { IdentityTypeDecorator } from "../decorators/identity-type.decorator";
import { CoreModel } from "./core-model";
import { ModelTypeNameDecorator } from "./decorators/model-type-name.decorator";
import { DynamicInternalIdentity } from "./dynamic-internal.identity";

@IdentityTypeDecorator(DynamicInternalIdentity)
@ModelTypeNameDecorator('DynamicInternal')
export class DynamicInternal extends CoreModel<DynamicInternalIdentity> {
    
    // Quando utilizziamo un DynamicInternal, dobbiamo specificare il nome del tipo di modello
    // Altrimenti tutti gli internal dinamici avranno lo stesso model type name
    constructor(customModelTypeName: string) {
        super(customModelTypeName);
    }
}